export function unpublished(page: {
  published_at: string | null;
  updated_at: string;
}): boolean {
  return (
    !page.published_at ||
    new Date(page.updated_at).getTime() > new Date(page.published_at).getTime()
  );
}

export function filterWebsitePages<
  T extends {
    id: number;
    title: string;
    slug: string;
    page_type: string;
    status: string;
    published_at?: string | null;
    updated_at?: string;
  },
>(
  pages: T[],
  search: string,
  type: string,
  state: string,
  selectedId?: number | null,
): T[] {
  const query = search.trim().toLowerCase();
  return pages
    .filter(
      (page) =>
        page.id === selectedId ||
        ((!query ||
          `${page.title} ${page.slug}`.toLowerCase().includes(query)) &&
          (!type || page.page_type === type) &&
          (!state ||
            (state === 'unpublished'
              ? !page.published_at ||
                (!!page.updated_at &&
                  unpublished({
                    ...page,
                    updated_at: page.updated_at,
                    published_at: page.published_at,
                  }))
              : page.status === state))),
    )
    .sort(
      (a, b) =>
        a.page_type.localeCompare(b.page_type) ||
        a.title.localeCompare(b.title),
    );
}

export function apiMessage(error: unknown, fallback: string): string {
  const body = (
    error as { responseData?: { error?: string; detail?: string } | string[] }
  )?.responseData;
  if (Array.isArray(body)) return body.join(' ');
  return body?.error || body?.detail || fallback;
}
